import React from 'react';
import { useGetTranslationsByCategoryQuery } from '@fiji/common/src/features/localization/localizationApi';
import i18next from '../utils/i18n';
import { useGetUserProfileQuery } from '@fiji/common/src/features/profile/profileApi';
import { ApiEndpointType, ApiResponseType } from '@fiji/common/src/features/common/commonTypes';
import { Profile } from '@fiji/common/src/types';
import { DEFAULT_LANGUAGE } from '@fiji/common/src/constants/cacheTimeout';

export const useCustomTranslations = (category: string[], skip?: boolean): any => {
    const { data: userProfileData } = useGetUserProfileQuery({}, { skip }) as ApiEndpointType<ApiResponseType<Profile>>;
    const globalLocale = window.localStorage.getItem('globalLocale');
    const language = userProfileData?.data?.language ?? globalLocale ?? DEFAULT_LANGUAGE;
    const { data, refetch, isFetching }: any = useGetTranslationsByCategoryQuery(
        {
            body: category[0],
            locale: language,
        },
        {
            skip: !userProfileData,
            refetchOnMountOrArgChange: true,
        }
    );

    React.useEffect(() => {
        if (data?.data) {
            i18next.addResourceBundle(language, category[0], data?.data, true, true);
        }
    }, [data, isFetching]);
    React.useEffect(() => {
        if (!i18next.hasResourceBundle(language, category[0]) && !skip) {
            refetch();
        }
    }, [category, skip]);
};
